module.exports = __webpack_public_path__ + "01_long_grey.6f0ee87a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/01_long_grey.png
// module id = 8oVZ
// module chunks = 0